import { ScrollToTop } from './ScrollToTop';
import { Navigate, Route, Routes } from 'react-router-dom';
import { APP_SHELL_MENU } from '../../_Config/AppShell.Layout';
import { CONFIG_PLUGIN } from "../../_Config/Plugins/_Config.Plugin";
import { AppLayoutPublic } from '../Templates/Layouts/AppLayoutPublic';
import { AppLayoutPrivate } from '../Templates/Layouts/AppLayoutPrivate';
import { AppGuard, AppGuestGuard } from '../Hooks/Contexts/_Auth/_App/_index';
import { useUserAuthenticated } from '../Hooks/Contexts/_Auth/userAuthenticatedContext';
import { ScreenForbidden, ScreenNotFound, ScreenMaintenance, PageLoader } from '../Templates/_UI/Screen/_index';

const ViewPlaceholder = ({ label, path }) => (
    <div style={{ padding: '48px 0' }}>
        <h1 style={{ fontSize: 28, margin: 0 }}>{label}</h1>
        <p style={{ opacity: .7 }}>Ruta <code>{path}</code> — vista pendiente de conectar.</p>
    </div>
);

const onFlattenRoutes = (items) => items.flatMap((item) => [
    item, ...(item.children ?? []).map((child) => ({ ...item, ...child, children: [] })),
]);

const onRenderRoutes = (items) => onFlattenRoutes(items).map((item) => (
    <Route key={item.path} path={item.path} element={item.component ?? <ViewPlaceholder label={item.label} path={item.path} />} />
));

const onRenderGuardedRoutes = (items) => onFlattenRoutes(items).map((item) => {

    const ELEMENT = item.component ?? <ViewPlaceholder label={item.label} path={item.path} />;

    if (!APP_SHELL_MENU.guards.isEnabled) {
        return <Route key={item.path} path={item.path} element={ELEMENT} />;
    }

    return (
        <Route key={item.path} path={item.path} element={
            <AppGuard roles={item.roles} permissions={item.permissions}
                redirectTo={APP_SHELL_MENU.guards.loginPath}
                forbiddenTo={APP_SHELL_MENU.guards.forbiddenPath} >
                {ELEMENT}
            </AppGuard>
        }
        />
    );
});

const onRenderPublicRoutes = (items) => onFlattenRoutes(items).map((item) => {
    
    const ELEMENT = item.component ?? <ViewPlaceholder label={item.label} path={item.path} />;
    const IS_GUEST_ONLY = item.isBlockedWhenLogged || APP_SHELL_MENU.guards.guestOnlyPaths.includes(item.path);

    if (!APP_SHELL_MENU.guards.isEnabled || !IS_GUEST_ONLY) {
        return <Route key={item.path} path={item.path} element={ELEMENT} />;
    }

    return (
        <Route key={item.path} path={item.path} element={
            <AppGuestGuard redirectTo={APP_SHELL_MENU.guards.afterLoginPath}>
                {ELEMENT}
            </AppGuestGuard>
        } />
    );
});

export const AppRouting = () => {

    const { useDataUserAuth: USER_AUTH, onCallbackCloseSessionUserAuth: ON_LOGOUT } = useUserAuthenticated();

    if (CONFIG_PLUGIN?.ROUTING?.HAS__MAINTENANCE_MODE === true) return <ScreenMaintenance />;

    return (

        <>
            <ScrollToTop />

            <Routes>
                <Route element={<AppLayoutPublic />}>
                    {onRenderPublicRoutes(APP_SHELL_MENU.publicRoutes)}
                </Route>

                <Route element={<AppLayoutPrivate user={USER_AUTH} onClickLogout={ON_LOGOUT} />}>
                    {onRenderGuardedRoutes(APP_SHELL_MENU.privateRoutes)}
                </Route>

                <Route path="/" element={
                    USER_AUTH?.isLoading
                        ? <PageLoader isFullScreen />
                        : <Navigate to={USER_AUTH?.isAuthenticated ? APP_SHELL_MENU.guards.afterLoginPath : APP_SHELL_MENU.guards.loginPath} replace />
                } />

                <Route element={<AppLayoutPublic />}>

                    <Route path={APP_SHELL_MENU.guards.forbiddenPath} element={<ScreenForbidden backTo="/" />} />

                    {
                        CONFIG_PLUGIN?.ROUTING?.HAS__REDIRECT_WHEN_PAGE_404 ? <Route path="*" element={<Navigate to="/" replace />} /> : <Route path="*" element={<ScreenNotFound homePath="/" />} />
                    }

                </Route>

            </Routes>
        </>
    );
};
